<template>

<app-table empty-message="There are no additional items attached." :empty="!items.length">

	<app-table-head :layout="layout">

		<app-table-column />

		<app-table-column text="Name" />

		<app-table-column text="Price" />

		<app-table-column align="center" text="Sold" />

	</app-table-head>

	<app-table-body>

		<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in items" :key="item.id">

			<app-table-cell-label text="Active" type="success" v-if="item.status === 1" :subtext="item.reference" />
		
            <app-table-cell-label text="Disabled" type="danger" v-if="item.status === 0" :subtext="item.reference" />
			
            <app-table-cell-text :text="item.name" />
			
            <app-table-cell-text v-if="!item.priceRange && item.charge" :text="item.price | formatMoney" :inline="true" :subtext="item.charge | formatMoney('+')" />
			
            <app-table-cell-text v-if="!item.priceRange && !item.charge" :text="item.price | formatMoney" />
			
            <app-table-cell-text v-if="item.priceRange" :text="priceRange(item)" />
			
            <app-table-cell-text align="center" :text="item.count.sold" />

		</app-table-row>

	</app-table-body>

</app-table>

</template>

<script>

export default {

	props: ['items'],

	data: function() {
	
		return {
			layout: '120px auto 200px 120px'
		}
	
	},

	methods: {
	
		onEditClick: function(id) {
		
			this.$router.push({
				name: 'Convention.Registration.Items.Edit',
				params: {
					id: id
				}
			})
		
		}
	
	}

}

</script>

<style scoped>

</style>